function SubmitController(clickCallback) {

	this.maxWords = 400;
	this.maxsize =

	this.setupForm();
	this.form_type = '';

	$('#nextFormPage').on('click', $.proxy( this.validatePageOne, this ) );
	$('#submitFormButton').on('click', $.proxy( this.validatePageTwo, this ) );
	$('.radio.type').on('click', $.proxy( this.handleRadioTypeClick, this ) );
	$('.radio.group').on('click', $.proxy( this.handleRadioGroupClick, this ) );
  $('.radio.optin').on('click', $.proxy( this.handleRadioOptinClick, this ) );
	$('.radio.terms').on('click', $.proxy( this.handleRadioTermsClick, this ) );
	$('#ArtistStatement').on( 'keyup', $.proxy( this.handleWordCount, this ) );
	$('#ArtistStatement').on( 'paste', $.proxy( this.handleWordCountChange, this ) );

	$('#main_file').on('change', function() { $("#main_file_name").val( this.value.replace("C:\\fakepath\\", "") ); } );
	$('#extra_file1').on('change', function() { $("#extra_file_name1").val( this.value.replace("C:\\fakepath\\", "") ); } );
	$('#extra_file2').on('change', function() { $("#extra_file_name2").val( this.value.replace("C:\\fakepath\\", "") ); } );
	$('#extra_file3').on('change', function() { $("#extra_file_name3").val( this.value.replace("C:\\fakepath\\", "") ); } );
	$('#extra_file4').on('change', function() { $("#extra_file_name4").val( this.value.replace("C:\\fakepath\\", "") ); } );

	$('input:file').on('change', $.proxy(this.checkFileSize, this) );

	$('.msContainer .closeButton').on('click',$.proxy( this.hideFormDownload, this ) );
	$('#showFormDownload').on('click',$.proxy( this.showFormDownload, this ) );

	$('#submitForm').on( 'submit', $.proxy( this.handleFormSubmit, this) );
	$(window).resize( $.proxy( this.handleResize, this ) );

	if( $('body').hasClass('EN') ) {
		$('#WordCount').text( this.maxWords + ' words left');
	} else {
		$('#WordCount').text( this.maxWords + ' à 400 mots');
	}


	this.spamInterval = setInterval( $.proxy( this.incrementSpamTimer, this ), 1000 );
	this.spamTime = 0;


	if(window.location.hash) {
	  if( window.location.hash == '#manual') {
	  	this.showFormDownload();
	  }
	}

}


SubmitController.prototype = {

	incrementSpamTimer:function() {
		this.spamTime++;
		console.log('ST: ' + this.spamTime );
	},

	showFormDownload:function() {

		$('.manualSubmitOverlay').fadeIn(400);

		var offset = ($(window).height() - $('.msContainer').height())/2;
		$('.msContainer').css('margin-top',offset+'px');
		ga('send', 'event', 'Submit', 'Download', 'Show' );

	},

	hideFormDownload:function() {

		$('.manualSubmitOverlay').fadeOut(400);
    ga('send', 'event', 'Submit', 'Download', 'Hide' );

	},

	checkFileSize: function(e) {
		var files = e.target.files;
		var main = false;
		var accept_types_main = [
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			"application/msword",
			"text/rtf",
			"text/plain",
			"image/jpeg",
			"application/pdf"
		];

		if( $(e.target).attr('id') == 'main_file') {
			main = true;
		}

		if( files ) {
			if( files[0].size > 5242880) {
				$(e.target).parent().parent().addClass('error');
			} else if( main && $.inArray(files[0].type,accept_types_main) < 0 ) {
				$(e.target).parent().parent().addClass('error');
			} else if( !main && files[0].type != 'image/jpeg' ) {
				$(e.target).parent().parent().addClass('error');
			} else {
				$(e.target).parent().parent().removeClass('error');
			}
		}


//			console.log(main,$(e.target).attr('id'),files[0].type, !$.inArray(files[0].type,accept_types_main) )

	},

	formSuccess: function(responseText, statusText, xhr, $form) {
		console.log('status: ' + statusText + '\n\nresponseText: \n' + responseText + '\n\nThe output div should have already been updated with the responseText.');
	},

	handleResize: function() {
		this.setupForm();
	},

	handleWordCount: function(e) {
		var words = $('#ArtistStatement').val().split(/\b[\s,\.-:;]*/);
		var wordcount = words.length;
		var wordsLeft = this.maxWords - wordcount;

		if( wordsLeft < 10 && wordsLeft > 0 ) {
			$('#WordCount').css('font-weight','700');
			$('#WordCount').css('color','');
			$('#ArtistStatement').off('keypress');
		} else if( wordsLeft <= 0 ) {
			$('#WordCount').css('color','#ee145b');
			$('#ArtistStatement').on('keypress',function(e){e.preventDefault();});
			//_gaq.push(['_trackEvent', 'Submit', 'WordCount', 'RunOut' ]);
      ga('send', 'event','Submit', 'WordCount', 'RunOut');

		} else {
			$('#ArtistStatement').off('keypress');
			$('#WordCount').css('color','');
			$('#WordCount').css('font-weight','');
		}

		if( $('body').hasClass('EN') ) {
			$('#WordCount').text( wordsLeft + ' words left');
		} else {
			$('#WordCount').text( wordsLeft + ' à 400 mots');
		}

	},

	handleWordCountChange: function() {

		setTimeout( $.proxy(function() {
			var words = $('#ArtistStatement').val().split(/\b[\s,\.-:;]*/);
			var wordcount = words.length;
			var wordsLeft = this.maxWords - wordcount;

			if( wordsLeft <= 0 ) {
				$('#WordCount').css('color','#ee145b');
				$('#WordCount').css('font-weight','700');
				$('#ArtistStatement').on('keypress',function(e){e.preventDefault();});
				//_gaq.push(['_trackEvent', 'Submit', 'WordCount', 'OverPaste' ]);
        ga('send', 'event', 'Submit', 'WordCount', 'OverPaste' );
			} else {
				$('#ArtistStatement').off('keypress');
				$('#WordCount').css('font-weight','');
			}

			if( $('body').hasClass('EN') ) {
				$('#WordCount').text( wordsLeft + ' words left');
			} else {
				$('#WordCount').text( wordsLeft + ' à 400 mots');
			}

		},this), 100);

	},

  handleRadioOptinClick:function(e) {

		$('.radio.optin').each(function() {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#optin').val($(e.currentTarget).data('value'));

	},

	handleRadioTypeClick:function(e) {

		$('.radio.type').each(function() {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#submit_type').val($(e.currentTarget).data('value'));

	},

	handleRadioGroupClick:function(e) {

		$('.radio.group').each(function() {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#group_submission').val($(e.currentTarget).data('value'));

	},

	handleRadioTermsClick:function(e) {

		$('.radio.terms').each(function() {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#terms_agreed').val($(e.currentTarget).data('value'));

	},

	validatePageOne: function() {

		$('#nextFormPage').off('click');
		$('#nextFormPage').css('opacity','0.2');

		var error = false;

		$('.page1 .formField.required').each( function(i) {

			//check the input field
			if( $(this).children('input').val() === '' || $(this).children('select').val() === '' ) {
				$(this).addClass('error');
				error = true;
			} else if( $(this).hasClass('error') ) {
				$(this).removeClass('error');
			}

		});

		if( error ) {
			$('#nextFormPage').on('click', $.proxy( this.validatePageOne, this ) );
			$('#nextFormPage').css('opacity','1');
			//IE8 HACK VVVV .. the complete function forces a redraw in IE8
			$('.page1 .formError').slideDown(200, function() { $('.submitForm').addClass('s').removeClass('s'); });
			//IE8 HACK ^^^^
			//_gaq.push(['_trackEvent', 'Submit', 'Page1', 'Error' ]);
      ga('send', 'event', 'Submit', 'Page1', 'Error'  );

			$(window).resize();
		} else {
			$('.page1').css('padding-bottom','0px');
			$('.page2').css('padding-bottom','100px');
			$('.page1 .formError').slideUp(200);
			$('.slideContainer.submitForm').animate({'margin-left':'-100%'}, 300 );
			$('html,body').animate( { scrollTop : $('.list.submit').offset().top - 110} , 350 );

			//_gaq.push(['_trackEvent', 'Submit', 'Page1', 'Complete' ]);
      ga('send', 'event',  'Submit', 'Page1', 'Complete');

		}


	},

	validatePageTwo: function() {

		$('#submitFormButton').off('click');
		$('#submitFormButton').addClass('submitting');

		var error = false;

		$('.page2 .formField.required').each( function(i) {

			//check the input field
			if( $(this).children('input').val() === '' || $(this).children('textarea').val() === '' ) {
				$(this).addClass('error');
				error = true;
			} else if( $(this).hasClass('error') ) {
				$(this).removeClass('error');
			}

		});

		if( $('#main_file_name').val() === '' ) {
			error=true;
			$('#mainFile').addClass('error');
		}

		if( parseInt($('#WordCount').text()) < 0 ) {
			error = true;
			$('#asContainer').addClass('error');
		}

		if( error ) {
			$('#submitFormButton').on('click', $.proxy( this.validatePageTwo, this ) );
			$('#submitFormButton').css('opacity','1');
			$('#submitFormButton').removeClass('submitting');
			//IE8 HACK VVVV .. the complete function forces a redraw in IE8
			$('.page2 .formError').slideDown(200, function() { $('.submitForm').addClass('s').removeClass('s'); });
			//_gaq.push(['_trackEvent', 'Submit', 'Page2', 'Error' ]);
      ga('send', 'event', 'Submit', 'Page2', 'Error' );

		} else {
			$('.page2 .formError').slideUp(200);

			console.log('ST TEST:' + this.spamTime );
			clearInterval( this.spamInterval );

			if( this.spamTime > 10 ) {
				$('#submitForm').attr('action', "/submit/process.php").submit();
			}

			//_gaq.push(['_trackEvent', 'Submit', 'Page2', 'Complete' ]);
      ga('send', 'event','Submit', 'Page2', 'Complete' );

		}



	},

	handleFormSubmit:function() {

		$('#submitForm').ajaxSubmit({ success: $.proxy(this.handleFormSuccess,this),error: $.proxy(this.handleFormError,this),dataType:'json' });
        return false;

	},

	handleFormError: function(responseText, statusText, xhr, $form) {
		alert('There has been a problem with your submission. We\'re sorry for the inconvenience. Please contact ourstory@HistoricaCanada.ca and let us know that you received the following error message:' + responseText );
		//_gaq.push(['_trackEvent', 'Submit', 'Page3', 'ErrorUnknown' ]);
    ga('send', 'event', 'Submit', 'Page3', 'ErrorUnknown');
	},

	handleFormSuccess: function(responseText, statusText, xhr, $form) {
		console.log(responseText);

		if( responseText.result != 1 ) {
			alert('There has been a problem with your submission. We\'re sorry for the inconvenience. Please contact ourstory@HistoricaCanada.ca and let us know that you received the following error message:' + responseText.message + " Code: " + responseText.result );
			//_gaq.push(['_trackEvent', 'Submit', 'Page3', 'Error' ]);
      ga('send', 'event', 'Submit', 'Page3', 'Error');
		} else {

			$('.page1, .page2').css('height','0px');
			$('.slideContainer.submitForm').animate({'margin-left':'-200%'}, 500 );
			$('html,body').animate( { scrollTop : $('.list.submit').offset().top - 100} , 350 );
			$('.list.submit').css('display','none');

			//_gaq.push(['_trackEvent', 'Submit', 'Page3', 'Success' ]);
      ga('send', 'event', 'Submit', 'Page3', 'Success');

		}

	},

	setupForm: function() {

		if( isMobile.any ) {

			$('.topCallout .nosubmit').css('display','block');
			$('.topCallout .submit').css('display','none');
			$('.submitForm').css('display','none');
			$('.list.submit').css('display','none');

		} else {

			$('.topCallout .nosubmit').css('display','none');
			$('.topCallout .submit').css('display','block');
			$('.submitForm').css('display','block');
			$('.list.submit').css('display','block');
		}

	}


};

module.exports = SubmitController;



// WEBPACK FOOTER //
// ./js/src/SubmitController.js